module.exports = __webpack_public_path__ + "static/media/cuperhidro.d6530deb.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/aguacate/climasense/antracnosis_aguacate/preventiva/cuperhidro.png
// module id = 1085
// module chunks = 3